import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { z } from 'zod';
import { Providers } from './app/Providers';
import { AppRoutes } from './app/routes';
import './index.css';

// The page's security policy forbids evaluating strings as code (ADR-027): zod validates
// without compiling, instead of probing for eval on every page.
z.config({ jitless: true });

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <Providers>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Providers>
  </StrictMode>,
);
